const messageDataAttr = 'data-tooltip-message';
const olyTooltipClass = 'oly-tooltip';
const isTooltipshownClass = 'is-tooltipShown';

const $ = require('jquery');

module.exports = function () {
    return {
        restrict: 'A',
        link(scope, element, attrs) {

            // Ensure that the ::after will be positioned correctly
            if (element.css('position') === 'static') {
                element.css('position', 'relative');
            }

            // Add the class that does most of the work
            element.addClass(olyTooltipClass);

            // Determine where the value should come from
            scope.$watch(attrs.olyTooltip, (val) => {
                element.attr(messageDataAttr, val);
            });

            element.on('touchstart', () => {
                element.toggleClass(isTooltipshownClass);

                setTimeout(() => {
                    $(document).off('touchstart.tooltip').one('touchstart.tooltip', () => {
                        element.removeClass(isTooltipshownClass);
                    });
                });
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/tooltip/tooltip.directive.js